import { render } from "./profitability-report.vue?vue&type=template&id=874c4308&scoped=true"
import script from "./profitability-report.vue?vue&type=script&lang=js"
export * from "./profitability-report.vue?vue&type=script&lang=js"

import "./profitability-report.vue?vue&type=style&index=0&id=874c4308&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-874c4308"]])

export default __exports__